/** Internal dashboards that must not emit MeritLens product analytics. */
export function isMeritLensAnalyticsExcludedPath(pathname: string | null | undefined): boolean {
  if (!pathname) return false;
  return pathname === "/marketing" || pathname.startsWith("/marketing/");
}
